import BaseService from './BaseService';

class AccountService extends BaseService {
    getAccountDetails = () => this.get('/get-account-details');

    updateAccountDetails = (data) => this.post('/edit-account-details', data);
}

export default new AccountService();
